import React, { useState, useEffect, useContext } from 'react';
import SettingApi from '../api/SettingApi';
import { SettingsContext } from '../Context/SettingContext';
import { PURCHASE_URL } from '../utils/constants';

const SettingForm = ({ toggle }) => {
  const nonce = devsAccountingApi.nonce;
  const [isToggle, setIsToggle] = useState(false);
  const [widthIncrease, setWidthIncrease] = useState(false);
  const { settings } = useContext(SettingsContext);
  const isPro = localStorage.getItem('dac_activation_license') === 'true';

  const handleAnimatedSwitch = () => {
    setWidthIncrease(true);
    setTimeout(() => {
      setWidthIncrease(false);
      setIsToggle(!isToggle);
    }, 300);
  };

  const [state, setState] = useState({
    company_name: '',
    address: '',
    phone: '',
    invoice_page: '',
    login_page: '',
    register_page: '',
    purchase_page : '',
    profile_page : '',
    payment: [],
    region: '',
    paypal_client_id: '',
    nonce: nonce,
    woocommerce_sync: false,
    dac_activation_license: null,
    order_sync: false,
  });

  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [fetchData, setFetchingData] = useState(true);
  const [statusOptions, setStatusOptions] = useState(['Cash']);

  useEffect(() => {
    fetchPages();
    getSettings();
  }, []);

  const getSettings = async () => {
    try {
      // const res = await SettingApi.index();
      const parsedData = settings;
      if (parsedData) {
        let paymentOptions = Array.isArray(parsedData.payment) ? [...parsedData.payment] : [];

        if (parsedData?.paypal_client_id && parsedData?.paypal_client_id.trim() !== "") {
          if (!paymentOptions.includes("PayPal")) {
            paymentOptions.push("PayPal");
          }
        }

        setState({
          company_name: parsedData.company_name,
          address: parsedData.address,
          phone: parsedData.phone,
          invoice_page: parsedData.invoice_page,
          login_page : parsedData.login_page,
          register_page : parsedData.register_page,
          purchase_page : parsedData.purchase_page,
          profile_page : parsedData.profile_page,
          payment: parsedData.payment,
          region: parsedData.region,
          paypal_client_id: parsedData.paypal_client_id,
          woocommerce_sync: parsedData.woocommercesync,
          order_sync: parsedData.ordersync,
          dac_activation_license: parsedData.dac_activation_license,
          nonce: nonce,
        });
        setStatusOptions(paymentOptions);
        setIsToggle(parsedData.paypal_client_id && parsedData.paypal_client_id.trim() !== "");
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  useEffect(() => {
    let paymentOptions = Array.isArray(state.payment) ? [...state.payment] : [];

    if (state.paypal_client_id && state.paypal_client_id.trim() !== "") {
      if (!paymentOptions.includes("PayPal")) {
        paymentOptions.push("PayPal");
      }
    } else {
      paymentOptions = paymentOptions.filter(option => option !== "PayPal");
    }
    if (!paymentOptions.includes("Cash")) {
      paymentOptions.push("Cash");
    }
  
  
    setStatusOptions(paymentOptions);
  }, [state.paypal_client_id, state.payment]);
  
  

  const fetchPages = async () => {
    try {
      const res = await SettingApi.page();
      setDatas(res);
      setFetchingData(false);
    } catch (error) {
      console.error('Error fetching WordPress pages:', error);
      setFetchingData(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  const handlePageChange = (e, pageType) => {
    const newPage = e.target.value;
    setState((prevState) => ({
      ...prevState,
      [pageType]: newPage,
    }));
  };

  const handleStatusChange = (index, event) => {
    const values = [...statusOptions];
    values[index] = event.target.value;
    setStatusOptions(values);
  };

  const handleAddStatusOption = () => {
    const values = [...statusOptions];
    values.push('');
    setStatusOptions(values);
  };

  const handleRemoveStatusOption = (index) => {
    const values = [...statusOptions];
    values.splice(index, 1);
    setStatusOptions(values);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const arrayData = {
      company_name: state.company_name,
      address: state.address,
      phone: state.phone,
      invoice_page: state.invoice_page,
      login_page: state.login_page,
      register_page : state.register_page,
      purchase_page : state.purchase_page,
      profile_page : state.profile_page,
      payment: statusOptions,
      paypal_client_id: state.paypal_client_id,
      region: state.region,
      woocommercesync: state.woocommerce_sync,
      ordersync: state.order_sync,
      dac_activation_license: state.dac_activation_license,
    };

    try {
      const res = await SettingApi.save({ arrayData });

      if (res?.message) {
        setMessage(res.message);
        setTimeout(() => setMessage(""), 5000);
      } else {
        setMessage("Unexpected response from server.");
      }
    } catch (error) {
      setMessage(error.response?.data?.message || "Error saving data");
      setTimeout(() => setMessage(""), 5000);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (e) => {
    const value = e.target.checked ? true : false;
    setState((prevState) => ({
      ...prevState,
      woocommerce_sync: value,
    }));
  };

  const handleCheckboxChangeOrder = (e) => {
    const value = e.target.checked ? true : false;
    setState((prevState) => ({
      ...prevState,
      order_sync: value,
    }));
  };



  return (
    <div>
      {message && (
        <div className="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3" role="alert">
          <p className="font-bold">{message}</p>
        </div>
      )}
      {!fetchData ? (
            <section >
              <form onSubmit={handleSubmit}>
              <div className="flex justify-between items-center bg-white px-6 py-4 border-b">
              <div className="text-lg text-gray-500">
              <h1>Settings</h1>

              </div>
              <div className="flex justify-end">
                <button
                  type="submit"
                  className="px-6 py-2 leading-5 text-white transition-colors duration-200 transform bg-gray-700 rounded-md hover:bg-gray-600 focus:outline-none focus:bg-gray-600"
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
              </div>
              <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4 bg-white p-6 ">
              <div>
                <label className="text-gray-700 dark:text-gray-200" htmlFor="company_name">Company Name</label>
                <input
                  id="company_name"
                  type="text"
                  className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                  name="company_name"
                  value={state.company_name}
                  onChange={handleInputChange}
                />
              </div>
              <div>
                <label className="text-gray-700 dark:text-gray-200" htmlFor="address">Address</label>
                <input
                  id="address"
                  type="text"
                  className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                  name="address"
                  value={state.address}
                  onChange={handleInputChange}
                />
              </div>
              <div>
                <label className="text-gray-700 dark:text-gray-200" htmlFor="phone">Phone</label>
                <input
                  id="phone"
                  type="text"
                  className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                  name="phone"
                  value={state.phone}
                  onChange={handleInputChange}
                />
              </div>
              <div>
                <label className="text-gray-700 dark:text-gray-200" htmlFor="phone">Date/Time Region</label>
                <input
                  id="region"
                  type="text"
                  className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                  name="region"
                  value={state.region}
                  onChange={handleInputChange}
                  placeholder='en-US'
                />
              </div>
              </div>
              <div className="mt-5 bg-white px-6 py-4 border-b">
              <h2 className="text-lg font-semibold text-gray-700 capitalize dark:text-white">Public Pages</h2>
              </div>
              <div className="w-full  bg-white p-6">
              <div className='grid sm:grid-cols-1 md:grid-cols-2 gap-4 mb-4 ' >
              <div className="w-full">
                <label className="text-gray-700 dark:text-gray-200" htmlFor="page-select">
                  Select a Page to show the invoice
                </label>
                <select
                  id="page-select"
                  className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                  value={state.invoice_page}
                  
                    onChange={(e) => handlePageChange(e, "invoice_page")}
                  name="page"
                >
                  <option value="">Select a page</option>
                  {datas.map((page) => (
                    <option key={page.id} value={page.slug}>
                      {page.title.rendered}
                    </option>
                  ))}
                </select>
              </div>
              <div className="w-full">
                <label className="text-gray-700 dark:text-gray-200" htmlFor="">
                  Or, Copy the Short Code
                </label>
                <input
                  type="text"
                  className="block w-[400px] px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                  placeholder="[devsaccounting_invoice]"
                  value="[devsaccounting_invoice]"
                  readOnly
                />
              </div>
              </div>
              <div className='grid sm:grid-cols-1 md:grid-cols-2 gap-4 mb-4' >
              <div>
                {!isPro && (
                  <div
                    onClick={() => window.open(PURCHASE_URL, '_blank')}
                    className="cursor-pointer text-blue-500"
                  >
                    <label className="text-gray-700 dark:text-gray-200" htmlFor="page-select">
                    <p>Select a Page to show</p>
                    <p className='inline-block'>Custom Register Page</p>
                    <span className='text-red-600 font-bold'>(Pro)</span>
                    </label>
                    <select
                      id="page-select"
                      className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                      disabled
                    >
                      <option value="">Select a page</option>
                    </select>
                  </div>
                )}

                {isPro && (
                  <div>
                    <label className="text-gray-700 dark:text-gray-200" htmlFor="page-select">
                    <p>Select a Page to show</p>
                    <p className='inline-block'>Custom Register Page</p>
                    <span className='text-red-600 font-bold'>(Pro)</span>
                    </label>
                    <select
                      id="page-select"
                      className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                      value={state.register_page}
                      onChange={(e) => handlePageChange(e, "register_page")}
                      name="page"
                    >
                      <option value="">Select a page</option>
                      {datas.map((page) => (
                        <option key={page.id} value={page.slug}>
                          {page.title.rendered}
                        </option>
                      ))}
                    </select>

                    {/* Shortcode for Pro users */}
                    <div>
                      <label className="text-gray-700 dark:text-gray-200" htmlFor="">
                        Or, Copy the Short Code
                      </label>
                      <input
                        type="text"
                        className="block w-[400px] px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                        placeholder="[devsaccounting_register]"
                        value="[devsaccounting_register]"
                        readOnly
                      />
                    </div>
                  </div>
                )}
              </div>

              </div>
              <div className='grid sm:grid-cols-1 md:grid-cols-2 gap-4 mb-4' >
              <div>
                {!isPro && (
                  <div
                    onClick={() => window.open(PURCHASE_URL, '_blank')}
                    className="cursor-pointer text-blue-500"
                  >
                    <label className="text-gray-700 dark:text-gray-200" htmlFor="page-select">
                    <p>Select a Page to show</p>
                    <p className='inline-block'>Custom Login Page</p>
                    <span className='text-red-600 font-bold'>(Pro)</span>
                    </label>
                    <select
                      id="page-select"
                      className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                      disabled
                    >
                      <option value="">Select a page</option>
                    </select>
                  </div>
                )}

                {isPro && (
                  <div>
                    <label className="text-gray-700 dark:text-gray-200" htmlFor="page-select">
                      <p>Select a Page to show</p>
                      <p className='inline-block'>Custom Login Page</p>
                      <span className='text-red-600 font-bold'>(Pro)</span>
                    </label>
                    <select
                      id="page-select"
                      className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                      value={state.login_page}
                      onChange={(e) => handlePageChange(e, "login_page")}
                      name="page"
                    >
                      <option value="">Select a page</option>
                      {datas.map((page) => (
                        <option key={page.id} value={page.slug}>
                          {page.title.rendered}
                        </option>
                      ))}
                    </select>

                    {/* Shortcode for Pro users */}
                    <div>
                      <label className="text-gray-700 dark:text-gray-200" htmlFor="">
                        Or, Copy the Short Code
                      </label>
                      <input
                        type="text"
                        className="block w-[400px] px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                        placeholder="[devsaccounting_login]"
                        value="[devsaccounting_login]"
                        readOnly
                      />
                    </div>
                  </div>
                )}
              </div>
              </div>
              <div className='grid sm:grid-cols-1 md:grid-cols-2 gap-4 mb-4' >
                <div>
                  {!isPro && (
                    <div
                      onClick={() => window.open(PURCHASE_URL, '_blank')}
                      className="cursor-pointer text-blue-500"
                    >
                      <label className="text-gray-700 dark:text-gray-200" htmlFor="page-select">
                        <p>Select a Page to show</p>
                        <p className='inline-block'>Custom Purchase Page</p>
                        <span className='text-red-600 font-bold'>(Pro)</span>
                      </label>
                      <select
                        id="page-select"
                        className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                        disabled
                      >
                        <option value="">Select a page</option>
                      </select>
                    </div>
                  )}

                  {isPro && (
                    <div>
                      <label className="text-gray-700 dark:text-gray-200" htmlFor="page-select">
                        <p>Select a Page to show</p>
                        <p className='inline-block'>Custom Purchase Page</p>
                        <span className='text-red-600 font-bold'>(Pro)</span>
                      </label>
                      <select
                        id="page-select"
                        className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                        value={state.purchase_page}
                        onChange={(e) => handlePageChange(e, "purchase_page")}
                        name="page"
                      >
                        <option value="">Select a page</option>
                        {datas.map((page) => (
                          <option key={page.id} value={page.slug}>
                            {page.title.rendered}
                          </option>
                        ))}
                      </select>

                      <div>
                        <label className="text-gray-700 dark:text-gray-200" htmlFor="">
                          Or, Copy the Short Code
                        </label>
                        <input
                          type="text"
                          className="block w-[400px] px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                          placeholder="[devsaccounting_purchase]"
                          value="[devsaccounting_purchase]"
                          readOnly
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='grid sm:grid-cols-1 md:grid-cols-2 gap-4 mb-4' >
                <div>
                {!isPro && (
                <div
                onClick={() => window.open(PURCHASE_URL, '_blank')}
                className="cursor-pointer text-blue-500"
                >
                <label className="text-gray-700 dark:text-gray-200" htmlFor="page-select">
                <p>Select a Page to show</p>
                <p className='inline-block'>Custom Profile Page</p>
                <span className='text-red-600 font-bold'>(Pro)</span>
                </label>
                <select
                id="page-select"
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                disabled
                >
                <option value="">Select a page</option>
                </select>
                </div>
                )}

                {isPro && (
                <div>
                <label className="text-gray-700 dark:text-gray-200" htmlFor="page-select">
                <p>Select a Page to show</p>
                <p className='inline-block'>Custom Profile Page</p>
                <span className='text-red-600 font-bold'>(Pro)</span>
                </label>
                <select
                id="page-select"
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                value={state.profile_page}
                onChange={(e) => handlePageChange(e, "profile_page")}
                name="page"
                >
                <option value="">Select a page</option>
                {datas.map((page) => (
                <option key={page.id} value={page.slug}>
                {page.title.rendered}
                </option>
                ))}
                </select>

                {/* Shortcode for Pro users */}
                <div>
                <label className="text-gray-700 dark:text-gray-200" htmlFor="">
                Or, Copy the Short Code
                </label>
                <input
                type="text"
                className="block w-[400px] px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                placeholder="[devsaccounting_profile]"
                value="[devsaccounting_profile]"
                readOnly
                />
                </div>
                </div>
                )}
                </div>
              </div>
              </div>

              <div className="mt-5 bg-white px-6 py-4 border-b">
              <h2 className="text-lg font-semibold text-gray-700 capitalize dark:text-white">Payment System</h2>
              </div>
              <div className="bg-white px-6 py-4">
              <div className="mb-4">
                {statusOptions?.map((status, index) => (
                  <div key={index} className="flex items-center mb-2">
                    <input
                      type="text"
                      value={status}
                      onChange={(e) => handleStatusChange(index, e)}
                      placeholder='Enter payment method'
                      className="block w-full lg:max-w-2xl px-4 py-2 mt-2 placeholder:text-xs text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                    />
                    {index === statusOptions.length - 1 && (
                      <button onClick={handleAddStatusOption} className="bg-blue-500 text-white px-2 py-1 rounded-md ml-2">+</button>
                    )}
                    {index !== 0 && (
                      <button onClick={() => handleRemoveStatusOption(index)} className="bg-red-500 text-white px-2 py-1 rounded-md ml-2">-</button>
                    )}
                  </div>
                ))}
              </div>


              <div>
                    <div className='flex items-center justify-between gap-2 border border-gray-300 px-4 py-1.5 rounded-md w-full lg:max-w-2xl'>
                        <span className='block '>PayPal</span>
                        <div
                        className={`${
                        isToggle
                          ? "!bg-[#3B9DF8] !border-[#3B9DF8]"
                          : "bg-[#f0f0f0] border-gray-200"
                        } border relative p-1 rounded-full w-[55px] cursor-pointer transition-all h-[25px] duration-200`}
                        onClick={handleAnimatedSwitch}
                        checked={state.paypal_client_id}
                        >
                        <div className="absolute inset-0 flex items-center justify-center">
                        <div
                          className={`${
                              isToggle
                                  ? "translate-x-[13px] !bg-white"
                                  : "translate-x-[-13px]"
                          } ${
                              widthIncrease ? "!w-[25px]" : "!w-[22px]"
                          } w-[22px] h-[22px] rounded-full bg-white transition-all duration-200`}
                        ></div>
                        </div>
                        </div>
                    </div>
                {isToggle && (
                  <>
                    <div className="my-2">
                
                      <input
                        type="text"
                        id="paypal_client_id"
                        name='paypal_client_id'
                        className="block w-full lg:max-w-2xl px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                        placeholder="Enter PayPal Client ID"
                        value={state.paypal_client_id}
                        onChange={handleInputChange}
                      />
                    </div>
                    <a
                      href="https://developer.paypal.com/dashboard/accounts"
                      target="_blank"
                      className="hover:underline-offset-1 text-blue-500 my-2.5 text-xs pl-4"
                    >
                      Get Your PayPal Client ID
                    </a>
                  </>
                )}
              </div>
              </div>

              </form>
              <div className='mt-4'>
                <div className="flex items-center space-x-2 ">
                    <input
                    type="checkbox"
                    id="checkbox"
                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 my-4"
                    onChange={handleCheckboxChange}
                    checked={state.woocommerce_sync === true}
                    disabled

                    />
                    <label
                    htmlFor="checkbox"
                    className="text-sm font-medium text-gray-700 cursor-pointer"
                    onClick={() => window.open(PURCHASE_URL, '_blank')}
                    >
                    <p className='inline-block'>Woocommerce Product Sync </p><span className='text-red-600 font-bold'> (Pro)</span> 
                    <p className='text-xs'>It will show woocommerce product into items and in dashboard</p>
                    </label>
                </div>
              <div className="flex items-start space-x-2">
                  <input
                  type="checkbox"
                  id="checkboxOrder"
                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 my-2"
                  onChange={handleCheckboxChangeOrder}
                  checked={state.order_sync === true}
                  disabled
                  />
                  <label
                  htmlFor="checkboxOrder"
                  className="text-sm font-medium text-gray-700 cursor-pointer"
                  onClick={() => window.open(PURCHASE_URL, '_blank')}
                  >
                  <p className='inline-block'>Woocommerce Order Sync </p><span className='text-red-600 font-bold'> (Pro)</span> 
                  <p className='text-xs'>It will show orders as invoice and summary in reports</p>
                  </label>
                </div>
                </div>
            </section>
            ) : (
              <p>Loading...</p>
            )}
    </div>
  );
};

export default SettingForm;
